import React from 'react'

import { CollapsibleProvider } from './CollapsibleProvider'

export type CollapsibleProps = {
  children: React.ReactNode
  defaultIsExpanded?: boolean
  isExpanded?: boolean
  onToggleExpand?: () => void
}

export const Collapsible = ({
  children,
  defaultIsExpanded,
  isExpanded,
  onToggleExpand,
}: CollapsibleProps) => {
  return (
    <CollapsibleProvider
      defaultIsExpanded={defaultIsExpanded}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
    >
      {children}
    </CollapsibleProvider>
  )
}
